import { Dispatch, SetStateAction } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { UserKeys } from '../../../../api/users-api';
import {
  AdministrationRoles,
  isAbleToSeeUIElement,
} from '../../../../utils/roles/client-roles';
import SharedToolbar from '../../../../shared/shared-toolbar-latest';
import SharedIconButton from '../../../../shared/buttons/shared-icon-button';

interface SecondaryDomainsToolbarProps {
  administrationRoles: string[];
  selectedRows: string[];
  containsDisabledDomains: boolean;
  containsEnabledDomains: boolean;
  setOpenDeleteSecondaryDomain: Dispatch<SetStateAction<boolean>>;
  setOpenAddSecondaryDomain: Dispatch<SetStateAction<boolean>>;
}

export default function SecondaryDomainsToolbar({
  administrationRoles,
  selectedRows,
  containsDisabledDomains,
  containsEnabledDomains,
  setOpenDeleteSecondaryDomain,
  setOpenAddSecondaryDomain,
}: SecondaryDomainsToolbarProps) {
  const queryClient = useQueryClient();

  return (
    <SharedToolbar
      noColumn
      noFilter
      secondaryButtons={
        <>
          <SharedIconButton
            variant="enable"
            disabled={
              selectedRows.length === 0 ||
              !isAbleToSeeUIElement(
                administrationRoles,
                AdministrationRoles.UpdateSecondaryDomains.value
              ) ||
              containsEnabledDomains
            }
            onClick={() => setOpenAddSecondaryDomain(true)}
            tooltipLabel={
              containsEnabledDomains
                ? 'All selected domains must be disabled'
                : 'Enable'
            }
          />
          <SharedIconButton
            variant="block"
            onClick={() => {
              setOpenDeleteSecondaryDomain(true);
            }}
            disabled={
              selectedRows.length === 0 ||
              !isAbleToSeeUIElement(
                administrationRoles || [],
                AdministrationRoles.UpdateSecondaryDomains.value
              ) ||
              containsDisabledDomains
            }
            tooltipLabel={
              containsDisabledDomains
                ? 'All selected domains must be enabled'
                : 'Disable'
            }
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              queryClient.invalidateQueries({
                queryKey: [UserKeys.AllPossibleDomains],
              });
            }}
            tooltipLabel="Refresh"
          />
        </>
      }
    />
  );
}
